export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden pt-16"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="absolute top-20 right-0 w-[55%] h-[85%] hidden md:block opacity-90">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20clean%20video%20streaming%20platform%20interface%20with%20cinematic%20movie%20posters%20grid%20layout%2C%20warm%20orange%20and%20amber%20accent%20colors%2C%20minimalist%20UI%20design%2C%20dark%20theme%20with%20soft%20gradients%2C%20play%20buttons%20and%20film%20strips%2C%20sleek%20and%20contemporary%20digital%20entertainment%20aesthetic%2C%20high%20quality%20render%20with%20subtle%20glow%20effects%2C%20professional%20media%20platform%20look&width=1400&height=900&seq=hero-visual-01&orientation=landscape"
          alt="白云视频高清在线观影平台界面展示"
          className="w-full h-full object-cover object-left rounded-l-3xl"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/70 to-transparent rounded-l-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-5">
            <i className="ri-fire-line text-base"></i>
            <span>全网热门影视免费看</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 font-heading leading-tight mb-4">
            白云视频 · 高清免费影视不卡顿
          </h1>

          <p className="text-lg md:text-xl text-primary-600 font-medium mb-6">
            西瓜视频同类型在线看剧体验，海量片库每日更新
          </p>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mb-8">
            白云视频致力于打造国内领先的免费高清影视平台，覆盖电影、电视剧、综艺、动漫等全品类内容。我们采用先进的视频分发技术，确保高清流畅不卡顿的观影体验，无论是西瓜视频免费还是糖豆视频、小蓝视频的同类资源，在这里都能找到。平台每日更新热门片源，追剧不等待，看片更畅快。
          </p>

          <div className="flex flex-wrap items-center gap-6 md:gap-8 mb-8">
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">30000+</span>
              <span className="text-xs text-foreground-500">影视资源</span>
            </div>
            <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">每日更新</span>
              <span className="text-xs text-foreground-500">最新片源</span>
            </div>
            <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">高清不卡顿</span>
              <span className="text-xs text-foreground-500">流畅体验</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <a
              href="#media"
              className="px-7 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>开始观影
            </a>
            <a
              href="#features"
              className="px-7 py-3 border-2 border-background-300 text-foreground-700 font-medium rounded-full hover:border-primary-300 hover:text-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              了解更多 <i className="ri-arrow-down-line ml-1"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}